import { COLORS } from "./colors";

export const DEFAULT_MAP_MARKER_COLOR = COLORS.PRIMARY;
export const SELECTED_MAP_MARKER_COLOR = "#0ea5e9";
export const DEFAULT_ZOOM = 15;
export const DEFAULT_ZOOM_MOBILE = 12;
export const FALLBACK_MAP_CENTER_ZOOM = 5;

// Fallback location when user denies geolocation permission
// Default to middle of the US
export const FALLBACK_MAP_CENTER = {
  lat: 39.833333,
  lng: -98.583333,
};
